<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6">
          <h5>Manage Hostel Attendance</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <!-- Filters -->
        <div class="row mb-3">
          <!-- Hostel Filter -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedHostel"
              placeholder="Filter by Hostel"
              style="width: 100%"
              allowClear
              @change="handleHostelChange"
            >
              <a-select-option v-for="h in hostels" :key="h.id" :value="h.id">
                {{ h.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Event -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedEventId"
              placeholder="Select Event"
              style="width: 100%"
              @change="handleEventChange"
            >
              <a-select-option v-for="event in filteredEvents" :key="event.id" :value="event.id">
                {{ event.name }}
                <small class="text-muted" v-if="event.hostel_id">({{ getHostelName(event.hostel_id) }})</small>
                <small class="text-muted" v-else>(Global)</small>
              </a-select-option>
            </a-select>
          </div>
          <!-- Date -->
          <div class="col-md-3 col-12 mb-2">
            <a-date-picker
              size="large"
              style="width: 100%"
              v-model="selectedDate"
              :format="dateFormat"
              :disabled-date="disabledDate"
              @change="handleDateChange"
            />
          </div>
        </div>

        <!-- Manage Attendance Table Component -->
        <div class="card">
          <div class="card-body">
            <a-spin :spinning="loading">
              <manage-attendance-table
                v-if="attendanceData && Object.keys(attendanceData).length > 0"
                :attendanceData="attendanceData"
                :attendanceDate="moment(selectedDate).format('YYYY-MM-DD')"
                :additionalData="{ hostel_event_id: selectedEventId }"
                apiEndpoint="/api/hostel/attendance"
                moduleType="hostel"
                :rolesetting="pagepermission"
                @submitted="handleAttendanceSubmitted"
              />
              <div v-else-if="!loading" class="text-center py-5">
                <span class="text-muted">Select an event and date to view attendance</span>
              </div>
            </a-spin>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ManageAttendanceTable from '@/components/attendance/ManageTable/index'

export default {
  name: 'HostelManageAttendanceView',
  components: {
    ManageAttendanceTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('hostel-facility', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loading: false,
      dateFormat: 'DD-MM-YYYY',

      hostels: [],
      events: [],
      selectedHostel: undefined,
      selectedEventId: undefined,
      selectedDate: moment(),

      attendanceData: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
        approvable: false,
      },
    }
  },
  computed: {
    filteredEvents() {
      if (!this.selectedHostel) {
        return this.events
      }
      return this.events.filter(e => e.hostel_id === null || e.hostel_id === this.selectedHostel)
    },
  },
  mounted() {
    this.fetchInitialData()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },
    fetchInitialData() {
      Promise.all([
        this.$http.get('/api/hostel'),
        this.$http.get('/api/hostel/event/all'),
      ])
        .then(([hostelsRes, eventsRes]) => {
          this.hostels = hostelsRes.data.data
          this.events = eventsRes.data.data || eventsRes.data
        })
    },
    getHostelName(hostelId) {
      const h = this.hostels.find(h => h.id === hostelId)
      return h ? h.name : ''
    },
    handleHostelChange(value) {
      this.selectedHostel = value || undefined
      if (this.selectedEventId) {
        const eventStillValid = this.filteredEvents.some(e => e.id === this.selectedEventId)
        if (!eventStillValid) {
          this.selectedEventId = undefined
          this.attendanceData = null
        }
      }
    },
    handleEventChange() {
      if (this.selectedEventId && this.selectedDate) {
        this.fetchAttendance()
      }
    },
    handleDateChange() {
      if (this.selectedEventId && this.selectedDate) {
        this.fetchAttendance()
      }
    },
    getRequestParams() {
      return {
        hostel_event_id: this.selectedEventId,
        date: moment(this.selectedDate).format('YYYY-MM-DD'),
      }
    },
    fetchAttendance() {
      if (!this.selectedEventId || !this.selectedDate) {
        this.$message.warning('Please select an event and a date.')
        return
      }
      this.loading = true
      this.$http.get('/api/hostel/attendance/data', {
        params: this.getRequestParams(),
      })
        .then(({ data }) => {
          this.attendanceData = data.data || data
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleAttendanceSubmitted() {
      this.fetchAttendance()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
